import React from 'react';
import InputField from 'Components/InputField/InputField';

const LoginField = () => {
  return (
    <InputField icon='/icons/user/userBlack.svg' placeholder='Email' />
  )
}

export default LoginField;